export default __webpack_public_path__ + "static/media/netfective.02666597.png";